module.exports = __webpack_public_path__ + "img/bar.340aaeb9.png";